import { Badge, IconButton } from "@mui/material";
import { ROUTES } from "constants/routes";
import { useNavigate } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { useAppSelector } from "store/appHooks";
import NotificationOpt from "./notification";

const NavIcons = () => {
  const { authReducer, userReducer, cartReducer }: any = useAppSelector(
    (state) => state
  );
  const { userProfile } = userReducer;
  const {
    isLoggedIn,
    loginState = { displayName: "", pic: "", email: "" },
    isLoadingAuth,
  } = authReducer;
  const navigate = useNavigate();
  return (
    <Fragment>
      {isLoggedIn && (
        <IconButton onClick={() => navigate(ROUTES.CART)}>
          <Badge badgeContent={cartReducer?.items?.length ?? 0} color="error">
            <img
              src="/assets/img/icons/cart_add.svg"
              height="20"
              width="20"
              alt=""
            />
          </Badge>
        </IconButton>
      )}

      {isLoggedIn && (
        <IconButton onClick={() => navigate("/messages")}>
          <Badge
            badgeContent={authReducer?.unReadMessages?.length ?? 0}
            color="error"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.98 14.79C17.98 15.05 17.97 15.3 17.94 15.54C17.71 18.24 16.12 19.58 13.19 19.58H12.79C12.54 19.58 12.3 19.7 12.15 19.9L10.95 21.5C10.42 22.21 9.56 22.21 9.03 21.5L7.82999 19.9C7.69999 19.73 7.41 19.58 7.19 19.58H6.79001C3.60001 19.58 2 18.79 2 14.79V10.79C2 7.86001 3.35001 6.27001 6.04001 6.04001C6.28001 6.01001 6.53001 6 6.79001 6H13.19C16.38 6 17.98 7.60001 17.98 10.79V14.79Z"
                stroke="#323232"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21.98 10.79C21.98 13.73 20.63 15.31 17.94 15.54C17.97 15.3 17.98 15.05 17.98 14.79V10.79C17.98 7.60001 16.38 6 13.19 6H6.79004C6.53004 6 6.28004 6.01001 6.04004 6.04001C6.27004 3.35001 7.86004 2 10.79 2H17.19C20.38 2 21.98 3.60001 21.98 6.79001V10.79Z"
                stroke="#323232"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.4955 13.25H13.5045"
                stroke="#323232"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.9955 13.25H10.0045"
                stroke="#323232"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.4955 13.25H6.5045"
                stroke="#323232"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Badge>
        </IconButton>
      )}
      {isLoggedIn && <NotificationOpt />}
    </Fragment>
  );
};

export default NavIcons;
